// extracted by mini-css-extract-plugin
export default {"hpHeader":"HomePage_hpHeader__LNM0w","buttons":"HomePage_buttons__IMHLo","main":"HomePage_main__K4Eu1"};